import { confirmDialog, type ConfirmDialogOptions } from '@/composables/useConfirmDialog'

/** 판매·관리·몰 화면 액션 전 공통 확인 (모달) */
export async function confirmAction(
  message: string,
  options: Omit<ConfirmDialogOptions, 'message'> = {},
): Promise<boolean> {
  return confirmDialog({
    message,
    ...options,
  })
}
